import _ from "lodash";
import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Website = ({ attribute }) => {
  const url = _.get(attribute, ["url"]);

  return (
    <Container>
      <iframe
        title={uuidv4()}
        src={url}
        style={{ width: "100%", height: "100%", border: 0 }}
      />
    </Container>
  );
};
